function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.288 512.288",
    style: {
      enableBackground: "new 0 0 512.288 512.288"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21246E"
    },
    d: "M512.288,398.656c0,10.501-8.503,19.004-19.004,19.004H19c-10.494,0-19-8.503-19-19.004V113.631   c0-10.494,8.506-19.003,19-19.003h474.285c10.501,0,19.004,8.509,19.004,19.003V398.656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M194.709,188.164l-57,136.015h-37.204l-28.03-108.536c-1.726-6.694-3.201-9.129-8.375-11.971   c-8.475-4.583-22.417-8.882-34.727-11.559l0.861-3.948H90.09c7.634,0,14.497,5.092,16.223,13.87l14.821,78.723l36.608-92.593   H194.709z M340.437,279.75c0.165-35.878-49.645-37.831-49.287-53.882c0.097-4.899,4.741-10.084,14.911-11.393   c5.05-0.672,18.948-1.164,34.7,6.067l6.174-28.829c-8.475-3.076-19.369-6.022-32.909-6.022c-34.775,0-59.257,18.497-59.463,44.963   c-0.228,19.572,17.466,30.493,30.813,37.011c13.705,6.67,18.287,10.928,18.239,16.909c-0.09,9.129-10.935,13.119-21.05,13.298   c-17.694,0.276-27.957-4.782-36.153-8.599l-6.37,29.821c8.209,3.769,23.409,7.042,39.14,7.235   C316.141,326.328,340.32,308.028,340.437,279.75 M432.271,324.178h32.55l-28.402-136.015H406.37c-6.752,0-12.444,3.938-14.98,9.97   l-52.766,126.044h36.932l7.331-20.313h45.145L432.271,324.178z M393.009,275.988l18.528-51.071l10.659,51.071H393.009z    M244.992,188.164L215.88,324.178h-35.192l29.119-136.015H244.992z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.26f35d5d438a9fcf25182658d6e2dedc.svg";
export { ForwardRef as ReactComponent };